export default {

    loadData({ commit, getters }, { token, type, env, config, init }) {
        commit('SET_ENV', { env })
        commit('SET_LOADING', true)

        let brand = ''
        if (config.brand_id) {
            brand = `&brand_id=${config.brand_id}`
        }

        window.axios
            .get(`${getters.baseUrl}/api/v1/ancillaries/booking?token=${token}${brand}`)
            .then(response => response.data)
            .then(data => {
                // console.log('starting to load data')
                commit('SAVE_INITIAL_DATA', { data, token, type, config, init })
                window.EventBus.dispatchEvent('ss-seat-selection-mounted')
            })
    },

    changeFlight({ commit, getters, dispatch }, selectedFlightId) {
        if (!getters.areSeatsSelectedCurrentFlight) {
            dispatch('showModal', { type: 'warning', text: getters.text.error_select_all_seats })
        } else if (!getters.isChildrenNotNextToAdultCurrentFlight) {
            dispatch('showModal', { type: 'warning', text: getters.text.error_children_near_adult })
        } else {
            if (selectedFlightId !== getters.flight.id) {
                commit('SET_LOADING', true)
            }
            setTimeout(() => {
                commit('CHANGE_FLIGHT', { selectedFlightId, getters })
            })
        }
    },

    nextFlight({ commit, getters, dispatch, state }, showModal) {
        if (getters.nextFlightId) {
            if (state.autoChangeFlight && showModal) {
                dispatch('showModal', { type: 'success', text: getters.text.modal_seat_selected })
            }
            dispatch('changeFlight', getters.nextFlightId)
        }
    },

    changePassenger({ commit }, selectedPassengerId) {
        commit('CHANGE_PASSENGER', selectedPassengerId)
    },

    selectSeat({ commit, getters }, selectedSeat) {
        commit('SELECT_SEAT', { selectedSeat, getters })
    },

    deselectSeat({ commit, getters }) {
        commit('DESELECT_SEAT', { getters })
    },

    selectSeatsAutomatically({ commit, getters }) {
        commit('SELECT_SEATS_AUTOMATICALLY', { getters })
    },

    showModal({ commit, getters }, { text, type }) {
        commit('SHOW_MODAL', { text, type })
    },

    hideModal({ commit, getters }) {
        commit('HIDE_MODAL')
    },

    toggleSelector({ state, commit, getters }) {
        if (state.isVisible) {
            window.EventBus.dispatchEvent('ss-seat-selection-hide')
            if (document.getElementById('passengers')) {
                document.getElementById('passengers').scrollLeft = 0
            }
        } else {
            window.EventBus.dispatchEvent('ss-seat-selection-show')
        }
        commit('TOGGLE_SELECTOR')
    },

    complete: function({ state, commit, dispatch, getters }) {
        if (!getters.areSeatsSelectedAllFlight) {
            dispatch('showModal', { type: 'warning', text: getters.text.error_select_all_seats })
        } else if (!getters.isChildrenNotNextToAdultAllFlight) {
            dispatch('showModal', { type: 'warning', text: getters.text.error_children_near_adult })
        } else {
            dispatch('toggleSelector')
            commit('SET_CONFIRMING')
                // console.log('called dispatcher')

            let selectedSeats = []
            let callbackSeats = []
            let callbackRemovedSeats = []

            state.data.flights.forEach((flight, flightIndex) => {
                flight.passengers.forEach((passenger, passengerIndex) => {
                    let info = {
                        journey: {
                            id: flight.id,
                            airline: flight.airline,
                            departure_airport: flight.departure_airport,
                            arrival_airport: flight.arrival_airport
                        },
                        passenger: {
                            id: passenger.id,
                            name: passenger.name
                        }
                    }

                    if (passenger.seat.designator != null) {
                        callbackSeats.push({
                            ...info,
                            seat: passenger.seat.designator,
                            seat_price: getters.formatPrice(passenger.seat.price),
                        })
                        selectedSeats.push({
                            flight: flight.id,
                            passenger: passenger.id,
                            seat: passenger.seat.designator,
                            seat_price: getters.formatPrice(passenger.seat.price),
                        })
                    } else {
                        let initialFlight = state.initialData.flights.find(flight2 => flight2.id === flight.id)
                        let initialPassenger = initialFlight.passengers.find(passenger2 => passenger2.id === passenger.id)
                        if (initialPassenger.seat.designator != null) {
                            callbackRemovedSeats.push({
                                ...info,
                                seat: initialPassenger.seat.designator,
                                seat_price: getters.formatPrice(passenger.seat.price),
                            })
                        }
                    }
                })
            })

            window.axios.post(`${getters.baseUrl}/api/v1/ancillaries/save-seats?token=${state.token}`, selectedSeats).then((response) => {
                window.EventBus.dispatchEvent('ss-seat-selection-completed', callbackSeats)
                if (callbackRemovedSeats.length > 0) {
                    window.EventBus.dispatchEvent('ss-seat-selection-removed', callbackRemovedSeats)
                }
                // console.log('done saving data')
                commit('COMPLETED', state.data)
                    // dispatch('toggleSelector')
            }).catch(function(error) {
                window.EventBus.dispatchEvent('ss-seat-selection-failed', callbackSeats)
            });
        }
    },

    setLoading({ commit }, loading) {
        commit('SET_LOADING', loading)
    }
}


// WEBPACK FOOTER //
// ./src/data/actions.js